import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-body" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-blue-alternate" }
const _hoisted_4 = {
  key: 2,
  class: "text-left"
}
const _hoisted_5 = { class: "row no-space" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "amount" }
const _hoisted_8 = {
  key: 0,
  class: "payout-gbp"
}
const _hoisted_9 = { class: "currency" }
const _hoisted_10 = { class: "exchange-rate" }
const _hoisted_11 = { class: "payout-type" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "account" }
const _hoisted_14 = { class: "requested-on" }
const _hoisted_15 = { class: "paid-on" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    ref: "dialog",
    class: "transaction-details-dialog",
    dismissible: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$gettext('Payout ID:')) + " ", 1),
          _createElementVNode("span", _hoisted_3, "  #" + _toDisplayString(_ctx.transactionId), 1)
        ]),
        (_ctx.error)
          ? (_openBlock(), _createBlock(_component_Notification, {
              key: 0,
              "icon-name": "danger",
              title: _ctx.$gettext('Oops! Something’s not right here.'),
              message: _ctx.$gettext('Please check your internet connection and reload the page.')
            }, null, 8, ["title", "message"]))
          : (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_Loader, { key: 1 }))
            : (_ctx.transaction)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, [
                        _withDirectives((_openBlock(), _createElementBlock("strong", null, [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("Payout", -1)
                        ]))])), [
                          [_directive_translate]
                        ]),
                        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(( _ctx.transaction.requestedAmount && _ctx.transaction.requestedCurrency )
                    ? _ctx.formatPrice(_ctx.transaction.requestedAmount, _ctx.transaction.requestedCurrency)
                    : _ctx.formatPrice(_ctx.transaction.amount, 'GBP')), 1)
                      ]),
                      (_ctx.displayPayoutInGbp)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                            _withDirectives((_openBlock(), _createElementBlock("strong", null, [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("Payout in GBP", -1)
                            ]))])), [
                              [_directive_translate]
                            ]),
                            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(`${_ctx.formatPrice(_ctx.transaction.amount, 'GBP')} GBP`), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_9, [
                        _withDirectives((_openBlock(), _createElementBlock("strong", null, [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("Amount Received", -1)
                        ]))])), [
                          [_directive_translate]
                        ]),
                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.transactionStatusPaid ? _ctx.amountReceived : '-'), 1)
                      ]),
                      _createElementVNode("p", _hoisted_10, [
                        _withDirectives((_openBlock(), _createElementBlock("strong", null, [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("Exchange rate", -1)
                        ]))])), [
                          [_directive_translate]
                        ]),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.exchangeRate), 1)
                      ]),
                      _createElementVNode("p", _hoisted_11, [
                        _withDirectives((_openBlock(), _createElementBlock("strong", null, [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("Payout type", -1)
                        ]))])), [
                          [_directive_translate]
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.transaction.type), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, [
                        _withDirectives((_openBlock(), _createElementBlock("strong", null, [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("Payout account", -1)
                        ]))])), [
                          [_directive_translate]
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.payoutAccount), 1)
                      ]),
                      _createElementVNode("p", _hoisted_14, [
                        _withDirectives((_openBlock(), _createElementBlock("strong", null, [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("Requested on", -1)
                        ]))])), [
                          [_directive_translate]
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.transaction.createdAt)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_15, [
                        _withDirectives((_openBlock(), _createElementBlock("strong", null, [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("Paid on", -1)
                        ]))])), [
                          [_directive_translate]
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                        (_ctx.transaction.paidOn)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.formatDate(_ctx.transaction.paidOn)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
                      ]),
                      _createElementVNode("p", _hoisted_18, [
                        _withDirectives((_openBlock(), _createElementBlock("strong", null, [...(_cache[16] || (_cache[16] = [
                          _createTextVNode("Status", -1)
                        ]))])), [
                          [_directive_translate]
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("strong", {
                          class: _normalizeClass(_ctx.getStatusClass(_ctx.transaction.status))
                        }, _toDisplayString(_ctx.$gettext(_ctx.getStatusText(_ctx.transaction.status))), 3)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 512))
}